import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PremiumModal = ({ onClose }) => {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <h2 className="lg:text-2xl text-lg font-bold text-center mb-3">
        Upgrade Plan
      </h2>

      <p className="lg:text-base text-sm text-center text-gray-600 mb-6">
        Upgrade your plan to unlock more features.
      </p>

      <div className="flex justify-center mb-8">
        <div className="w-28 h-24 lg:w-64 lg:h-40 rounded-2xl bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center shadow-lg">
          <div className="w-14 h-14 rounded-2xl bg-white/10 flex items-center justify-center">
            <Lock className="text-white" />
          </div>
        </div>
      </div>

      <div className="flex flex-row gap-3">
          <button
            type="button"
            onClick={() => navigate("/pricing")}
            className="w-full bg-orange-500 text-white py-2.5 lg:py-3.5 rounded-xl text-base font-semibold hover:bg-orange-600 transition"
          >
            Upgrade Now
          </button>
          <button
            type="button"
            onClick={onClose}
            className="w-full py-2.5 lg:py-3.5 rounded-xl text-base font-semibold border border-gray-200 hover:bg-gray-50 transition"
          >
          Not now
        </button>
      </div>
    </div>
  );
};

export default PremiumModal;
  